import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWindowsWhiteIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 452.986 452.986",
	style: { enableBackground: "new 0 0 452.986 452.986" },
	xmlSpace: "preserve",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		style: { fill: "currentColor" },
		d: "M165.265,53.107L21.689,81.753v132.531l143.575-2.416V53.107 M431.297,245.583l-233.18-3.991 v164.822l233.18,46.571V245.583 M165.265,241.097l-143.575-2.438v132.509l143.575,28.668V241.097 M431.297,0l-233.18,46.528 v164.822l233.18-3.969V0"
	}) })
});
export default SvgWindowsWhiteIcon;
